import { DATA_LOADING_STATES, METRIC_NAMES, SORT_DIRECTION } from '@config/Consts';
import { SKILL_LIST_RESOURCES } from './Consts';

export default {
  skillsMetrics: null,
  dataStatus: {
    [SKILL_LIST_RESOURCES.METRICS]: DATA_LOADING_STATES.NONE,
    [SKILL_LIST_RESOURCES.MESSAGING_CURRENT_QUEUE_HEALTH]: DATA_LOADING_STATES.NONE,
  },
  lastTimeDataUpdated: {
    [SKILL_LIST_RESOURCES.METRICS]: null,
    [SKILL_LIST_RESOURCES.MESSAGING_CURRENT_QUEUE_HEALTH]: null,
  },
  currentPageSkillIds: [],
  lastResponses: {
    [SKILL_LIST_RESOURCES.MESSAGING_CURRENT_QUEUE_HEALTH]: [],
  },
  sort: {
    columnName: METRIC_NAMES.SKILL_ASSIGNED_CONVERSATIONS,
    direction: SORT_DIRECTION.DESCENDING,
  },
};
